<template>
  <p class="font-weight-bold">
    <span v-for="slug in slugs" :key="slug">{{ slug.toUpperCase() }} > </span>
  </p>
</template>

<script>
export default {
  name: 'BasePageHistoryNavigator',
  data() {
    return {
      slugs: [],
    }
  },
  mounted() {
    let currentLoc = this.$route.path.split('/')
    currentLoc.shift()
    this.slugs = currentLoc
  },
}
</script>

<style></style>
